module.exports = __webpack_public_path__ + "img/pt-33.d9159b30.jpg";